import React from 'react';
import { StyledPaperContainer } from '../../../../PlusWebsiteEditor/PlusWebsiteEditor.styles';
import { ColumnWithGap } from '../../../../PlusWebsiteEditor/sections/HeroBlock/HeroBlock.styled';
import { ConditionEditorProps } from './interface';
import ConditionEditorHeader from './ConditionEditorHeader';
import ConditionEditorBody from './ConditionEditorBody';

const ConditionEditor = ({ form, condition, index, clinicId }: ConditionEditorProps) => {
  return (
    <StyledPaperContainer>
      <ColumnWithGap>
        <ConditionEditorHeader condition={condition} form={form} index={index} clinicId={clinicId} />
        <ConditionEditorBody form={form} index={index} clinicId={clinicId} />
      </ColumnWithGap>
    </StyledPaperContainer>
  );
};

export default ConditionEditor;
